import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconInformationError = function IconInformationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10m2 0c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.879 8.464A1 1 0 0 0 8.464 9.88L10.586 12l-2.122 2.122a1 1 0 1 0 1.414 1.415L12 13.414l2.121 2.122a1 1 0 0 0 1.414-1.415L13.415 12l2.12-2.121a1 1 0 0 0-1.414-1.415L12 10.586z"
  }));
};